import '../../css/study.css'
import Content from './Content';
import Nav from './Nav';
import Header from './Header';
import Footer from './Footer';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import API from '../../services/API/Study';
import Loader from '../Tools/Loader';
import { Alert } from '@mui/material';
import useFirstSection from './Hooks/useFirstSection';
import { txt } from '../../services/translation';
import useStore from './Hooks/useStore';
import { useEffect } from 'react';
import moment from 'moment';
import isScreenSmall from './isScreenSmall';

export default function Study(){

    const navigate = useNavigate();

    const {course, tab} = useParams();

    const {nav, toggleNav, setupNav, resetNav} = useStore();

    const firstSection = useFirstSection();

    useEffect(() => {

        setupNav()

        return () => resetNav()

    }, [setupNav, resetNav])

    const data = useQuery({

        queryKey: course,

        queryFn: () => API.getCourse(course).then(r => r.data),

        onSuccess: data => {

            const first = !tab && firstSection();

            if(first) navigate(`/study/${data.id}/${first.id}`);
        }
    })

    if( data.isLoading ) return <Loader />

    if( data.isError ) return <Alert severity='warning'>{txt('notEnrolledInCourse')}</Alert>

    /**
     * A learner put in a session sees only the chapters of its program. That
     * program can hold nothing yet, and navigating to a section that does not
     * exist used to leave him on a blank screen.
     */
    if( data.isSuccess && !data.data.chapters.some(c => c.sections.length) ){

        const session = data.data.session;
        const notStarted = session && session.started === false;

        return <Alert severity='info' sx={{m: 2}}>
            {notStarted
                ? `Votre session « ${session.title} » démarre le ${moment(session.start).format('DD/MM/YYYY')}. Les chapitres seront visibles à cette date.`
                : "Aucun contenu n'est disponible pour l'instant dans cette formation."
            }
        </Alert>
    }


    return data.isSuccess &&
    
        <div className='study'>


            <Nav open={nav} onClose={toggleNav} />


            {(isScreenSmall() ? !nav : true) &&

                <main className='study-main'>

                    <Header nav={nav} onNavToggle={toggleNav}  />

                    <Content />

                    <Footer />

                </main> 
            }

        </div>
}